export const FORM_BUILDER = {
  PDF: 'pdf',
  COLLECTION: 'collection',
} as const;

export default undefined;